import { useState } from "react";
import useTranslation from "@babackapp/translations/use-translation";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@babackapp/ui/components/select";
import { useCarriersContext } from "../../use-carriers-context";
import {
  FEDEX_PLAN_CUSTOM,
  FEDEX_PLAN_OPTIONS,
  resolveInitialPlan,
} from "../fedex-plans";

// Dropdown to pick the FedEx "shipping plan" for an already-registered FedEx
// carrier. Saving persists only the `fedexPlan` key; the backend derives the
// shipment values from it.
export function FedexPlanSelect({
  carrierId,
  currentPlan,
}: {
  carrierId: string;
  currentPlan?: string | null;
}) {
  const t = useTranslation();
  const { editOneCarrierTransport } = useCarriersContext();
  const [value, setValue] = useState(() => resolveInitialPlan(currentPlan));

  const handleChange = (plan: string) => {
    setValue(plan);
    editOneCarrierTransport({
      carrierId,
      carrier: { code: "fedex", credentials: { fedexPlan: plan } },
    });
  };

  return (
    <div className="space-y-1.5">
      <label className="block text-sm font-medium text-gray-700">
        {t("carrier.fedexCsp.planLabel")}
      </label>
      <Select value={value} onValueChange={handleChange}>
        <SelectTrigger>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {FEDEX_PLAN_OPTIONS.map((option) => (
            <SelectItem key={option.key} value={option.key}>
              {t(option.labelKey)}
            </SelectItem>
          ))}
          {currentPlan === FEDEX_PLAN_CUSTOM && (
            <SelectItem value={FEDEX_PLAN_CUSTOM} disabled>
              {t("carrier.fedexCsp.plan.custom")}
            </SelectItem>
          )}
        </SelectContent>
      </Select>
      <p className="text-xs text-gray-500">
        {t("carrier.fedexCsp.planHelper")}
      </p>
    </div>
  );
}
